import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _71d930fe = () => interopDefault(import('../pages/address-book/index.vue' /* webpackChunkName: "pages/address-book/index" */))
const _6357f377 = () => interopDefault(import('../pages/company/index.vue' /* webpackChunkName: "pages/company/index" */))
const _0b2693ae = () => interopDefault(import('../pages/company-panel/index.vue' /* webpackChunkName: "pages/company-panel/index" */))
const _d9c07250 = () => interopDefault(import('../pages/contractors/index.vue' /* webpackChunkName: "pages/contractors/index" */))
const _969cf0a8 = () => interopDefault(import('../pages/crews/index.vue' /* webpackChunkName: "pages/crews/index" */))
const _fc6a1e82 = () => interopDefault(import('../pages/employees/index.vue' /* webpackChunkName: "pages/employees/index" */))
const _16410dfe = () => interopDefault(import('../pages/equipments/index.vue' /* webpackChunkName: "pages/equipments/index" */))
const _b2f06e90 = () => interopDefault(import('../pages/hazard-register/index.vue' /* webpackChunkName: "pages/hazard-register/index" */))
const _13f3141b = () => interopDefault(import('../pages/incidents/index.vue' /* webpackChunkName: "pages/incidents/index" */))
const _3cc9dca0 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _2ebfc8e8 = () => interopDefault(import('../pages/machines/index.vue' /* webpackChunkName: "pages/machines/index" */))
const _89afd70a = () => interopDefault(import('../pages/reminders/index.vue' /* webpackChunkName: "pages/reminders/index" */))
const _08ad5928 = () => interopDefault(import('../pages/safety-alerts/index.vue' /* webpackChunkName: "pages/safety-alerts/index" */))
const _4d2e8f3f = () => interopDefault(import('../pages/settings/index.vue' /* webpackChunkName: "pages/settings/index" */))
const _5e6853f4 = () => interopDefault(import('../pages/sites/index.vue' /* webpackChunkName: "pages/sites/index" */))
const _497e3ac6 = () => interopDefault(import('../pages/summary.vue' /* webpackChunkName: "pages/summary" */))
const _308e3f60 = () => interopDefault(import('../pages/summary/index.vue' /* webpackChunkName: "pages/summary/index" */))
const _ac614c80 = () => interopDefault(import('../pages/summary/crews.vue' /* webpackChunkName: "pages/summary/crews" */))
const _06dde1ef = () => interopDefault(import('../pages/summary/incidents.vue' /* webpackChunkName: "pages/summary/incidents" */))
const _97fb0374 = () => interopDefault(import('../pages/support.vue' /* webpackChunkName: "pages/support" */))
const _6a9d292c = () => interopDefault(import('../pages/training-competency/index.vue' /* webpackChunkName: "pages/training-competency/index" */))
const _17f7a63a = () => interopDefault(import('../pages/vehicles/index.vue' /* webpackChunkName: "pages/vehicles/index" */))
const _33f12e0e = () => interopDefault(import('../pages/company-panel/view.vue' /* webpackChunkName: "pages/company-panel/view" */))
const _149590bc = () => interopDefault(import('../pages/company-panel/view/index.vue' /* webpackChunkName: "pages/company-panel/view/index" */))
const _023ba605 = () => interopDefault(import('../pages/company-panel/view/edit-details.vue' /* webpackChunkName: "pages/company-panel/view/edit-details" */))
const _3aed65b9 = () => interopDefault(import('../pages/company-panel/view/manage-access/index.vue' /* webpackChunkName: "pages/company-panel/view/manage-access/index" */))
const _33079860 = () => interopDefault(import('../pages/company-panel/view/manage-crews.vue' /* webpackChunkName: "pages/company-panel/view/manage-crews" */))
const _40025ba3 = () => interopDefault(import('../pages/company-panel/view/manage-employees.vue' /* webpackChunkName: "pages/company-panel/view/manage-employees" */))
const _4268a98e = () => interopDefault(import('../pages/company-panel/view/manage-access/view.vue' /* webpackChunkName: "pages/company-panel/view/manage-access/view" */))
const _3d074d91 = () => interopDefault(import('../pages/company-panel/view/manage-access/view/index.vue' /* webpackChunkName: "pages/company-panel/view/manage-access/view/index" */))
const _f11287b6 = () => interopDefault(import('../pages/company-panel/view/manage-access/view/groups.vue' /* webpackChunkName: "pages/company-panel/view/manage-access/view/groups" */))
const _43b66c10 = () => interopDefault(import('../pages/company/view.vue' /* webpackChunkName: "pages/company/view" */))
const _b334b2da = () => interopDefault(import('../pages/company/view/index.vue' /* webpackChunkName: "pages/company/view/index" */))
const _edc44490 = () => interopDefault(import('../pages/company/view/files.vue' /* webpackChunkName: "pages/company/view/files" */))
const _de55dd2e = () => interopDefault(import('../pages/company/view/objectives.vue' /* webpackChunkName: "pages/company/view/objectives" */))
const _5b626fc1 = () => interopDefault(import('../pages/company/view/policy.vue' /* webpackChunkName: "pages/company/view/policy" */))
const _ba87d2a6 = () => interopDefault(import('../pages/contractors/company-files.vue' /* webpackChunkName: "pages/contractors/company-files" */))
const _5841ebcd = () => interopDefault(import('../pages/employees/new.vue' /* webpackChunkName: "pages/employees/new" */))
const _118e0310 = () => interopDefault(import('../pages/equipments/add.vue' /* webpackChunkName: "pages/equipments/add" */))
const _0cd993ae = () => interopDefault(import('../pages/incidents/new.vue' /* webpackChunkName: "pages/incidents/new" */))
const _1981be92 = () => interopDefault(import('../pages/machines/add.vue' /* webpackChunkName: "pages/machines/add" */))
const _2dc315ba = () => interopDefault(import('../pages/safety-alerts/new.vue' /* webpackChunkName: "pages/safety-alerts/new" */))
const _620c2e9f = () => interopDefault(import('../pages/sites/register.vue' /* webpackChunkName: "pages/sites/register" */))
const _1305fc3c = () => interopDefault(import('../pages/sites/register/index.vue' /* webpackChunkName: "pages/sites/register/index" */))
const _49c719e7 = () => interopDefault(import('../pages/sites/register/_forestid.vue' /* webpackChunkName: "pages/sites/register/_forestid" */))
const _48b24772 = () => interopDefault(import('../pages/vehicles/add.vue' /* webpackChunkName: "pages/vehicles/add" */))
const _18b60f45 = () => interopDefault(import('../pages/reminders/goto/crewgear.vue' /* webpackChunkName: "pages/reminders/goto/crewgear" */))
const _7d7d8ddc = () => interopDefault(import('../pages/reminders/goto/employeegear.vue' /* webpackChunkName: "pages/reminders/goto/employeegear" */))
const _474cbe82 = () => interopDefault(import('../pages/company-panel/manage-access/group/_groupuuid.vue' /* webpackChunkName: "pages/company-panel/manage-access/group/_groupuuid" */))
const _64e66e98 = () => interopDefault(import('../pages/company-panel/manage-access/user/_useruuid.vue' /* webpackChunkName: "pages/company-panel/manage-access/user/_useruuid" */))
const _cb25d5e6 = () => interopDefault(import('../pages/company/program/_versionid/index.vue' /* webpackChunkName: "pages/company/program/_versionid/index" */))
const _2f6e5ef2 = () => interopDefault(import('../pages/company/program/_versionid/policy.vue' /* webpackChunkName: "pages/company/program/_versionid/policy" */))
const _442f942a = () => interopDefault(import('../pages/employees/_id/index.vue' /* webpackChunkName: "pages/employees/_id/index" */))
const _749ea986 = () => interopDefault(import('../pages/incidents/_id/index.vue' /* webpackChunkName: "pages/incidents/_id/index" */))
const _3ceb1590 = () => interopDefault(import('../pages/sites/_siteid/index.vue' /* webpackChunkName: "pages/sites/_siteid/index" */))
const _48433d23 = () => interopDefault(import('../pages/summarynew/_drillid.vue' /* webpackChunkName: "pages/summarynew/_drillid" */))
const _5e424ec1 = () => interopDefault(import('../pages/contractors/_companyid/agreement/index.vue' /* webpackChunkName: "pages/contractors/_companyid/agreement/index" */))
const _2cdd315b = () => interopDefault(import('../pages/contractors/_companyid/company-files.vue' /* webpackChunkName: "pages/contractors/_companyid/company-files" */))
const _cae3b2dc = () => interopDefault(import('../pages/contractors/_companyid/reviews/index.vue' /* webpackChunkName: "pages/contractors/_companyid/reviews/index" */))
const _36b6f3de = () => interopDefault(import('../pages/crews/_crewid/documents.vue' /* webpackChunkName: "pages/crews/_crewid/documents" */))
const _53e89be1 = () => interopDefault(import('../pages/crews/_crewid/documents/index.vue' /* webpackChunkName: "pages/crews/_crewid/documents/index" */))
const _36a0d306 = () => interopDefault(import('../pages/crews/_crewid/documents/files.vue' /* webpackChunkName: "pages/crews/_crewid/documents/files" */))
const _338cfd3b = () => interopDefault(import('../pages/crews/_crewid/documents/gear-tracker.vue' /* webpackChunkName: "pages/crews/_crewid/documents/gear-tracker" */))
const _316fa4a3 = () => interopDefault(import('../pages/crews/_crewid/documents/safe-start.vue' /* webpackChunkName: "pages/crews/_crewid/documents/safe-start" */))
const _54a33523 = () => interopDefault(import('../pages/crews/_crewid/documents/substance-inv.vue' /* webpackChunkName: "pages/crews/_crewid/documents/substance-inv" */))
const _4933ca33 = () => interopDefault(import('../pages/crews/_crewid/monthly.vue' /* webpackChunkName: "pages/crews/_crewid/monthly" */))
const _c142c314 = () => interopDefault(import('../pages/crews/_crewid/monthly/index.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/index" */))
const _ef0c47f8 = () => interopDefault(import('../pages/crews/_crewid/monthly/audits.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/audits" */))
const _82d4bf80 = () => interopDefault(import('../pages/crews/_crewid/monthly/emergency-drills.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/emergency-drills" */))
const _18442c57 = () => interopDefault(import('../pages/crews/_crewid/monthly/safety-meetings.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/safety-meetings" */))
const _5101b852 = () => interopDefault(import('../pages/crews/_crewid/monthly/safety-review.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/safety-review" */))
const _0fa7d7ff = () => interopDefault(import('../pages/crews/_crewid/monthly/sbos.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/sbos" */))
const _4a3f9cfa = () => interopDefault(import('../pages/crews/_crewid/monthly/system-audits.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/system-audits" */))
const _7b22809a = () => interopDefault(import('../pages/crews/_crewid/monthly/toolbox/index.vue' /* webpackChunkName: "pages/crews/_crewid/monthly/toolbox/index" */))
const _3c981330 = () => interopDefault(import('../pages/crews/_crewid/monthly/toolbox/toolbox.unit.js' /* webpackChunkName: "pages/crews/_crewid/monthly/toolbox/toolbox.unit" */))
const _001461e2 = () => interopDefault(import('../pages/employees/_id/edit.vue' /* webpackChunkName: "pages/employees/_id/edit" */))
const _30432e06 = () => interopDefault(import('../pages/employees/_id/view.vue' /* webpackChunkName: "pages/employees/_id/view" */))
const _26750480 = () => interopDefault(import('../pages/employees/_id/view/index.vue' /* webpackChunkName: "pages/employees/_id/view/index" */))
const _261bb0c6 = () => interopDefault(import('../pages/employees/_id/view/compliance.vue' /* webpackChunkName: "pages/employees/_id/view/compliance" */))
const _d752c83a = () => interopDefault(import('../pages/employees/_id/view/drug-alcohol.vue' /* webpackChunkName: "pages/employees/_id/view/drug-alcohol" */))
const _61049636 = () => interopDefault(import('../pages/employees/_id/view/files.vue' /* webpackChunkName: "pages/employees/_id/view/files" */))
const _ec5e2ac6 = () => interopDefault(import('../pages/employees/_id/view/forms.vue' /* webpackChunkName: "pages/employees/_id/view/forms" */))
const _90f76ca2 = () => interopDefault(import('../pages/employees/_id/view/induction.vue' /* webpackChunkName: "pages/employees/_id/view/induction" */))
const _5be498ca = () => interopDefault(import('../pages/employees/_id/view/linked.vue' /* webpackChunkName: "pages/employees/_id/view/linked" */))
const _2d56fa7f = () => interopDefault(import('../pages/employees/_id/view/medical.vue' /* webpackChunkName: "pages/employees/_id/view/medical" */))
const _1d9b853e = () => interopDefault(import('../pages/employees/_id/view/ppe-tracker.vue' /* webpackChunkName: "pages/employees/_id/view/ppe-tracker" */))
const _df95daf0 = () => interopDefault(import('../pages/employees/_id/view/record-learning.vue' /* webpackChunkName: "pages/employees/_id/view/record-learning" */))
const _35de535e = () => interopDefault(import('../pages/employees/_id/view/training-records.vue' /* webpackChunkName: "pages/employees/_id/view/training-records" */))
const _a0902a84 = () => interopDefault(import('../pages/equipments/_equipmentid/edit.vue' /* webpackChunkName: "pages/equipments/_equipmentid/edit" */))
const _6bb55df3 = () => interopDefault(import('../pages/equipments/_equipmentid/files.vue' /* webpackChunkName: "pages/equipments/_equipmentid/files" */))
const _0a92c080 = () => interopDefault(import('../pages/equipments/_equipmentid/induction/index.vue' /* webpackChunkName: "pages/equipments/_equipmentid/induction/index" */))
const _f7fb45ba = () => interopDefault(import('../pages/equipments/_equipmentid/prepurchase/index.vue' /* webpackChunkName: "pages/equipments/_equipmentid/prepurchase/index" */))
const _6cff3106 = () => interopDefault(import('../pages/incidents/_id/edit.vue' /* webpackChunkName: "pages/incidents/_id/edit" */))
const _5882d0d2 = () => interopDefault(import('../pages/machines/_machineid/checklist/index.vue' /* webpackChunkName: "pages/machines/_machineid/checklist/index" */))
const _03ff21e8 = () => interopDefault(import('../pages/machines/_machineid/edit.vue' /* webpackChunkName: "pages/machines/_machineid/edit" */))
const _33053936 = () => interopDefault(import('../pages/machines/_machineid/files.vue' /* webpackChunkName: "pages/machines/_machineid/files" */))
const _70b01f72 = () => interopDefault(import('../pages/machines/_machineid/induction/index.vue' /* webpackChunkName: "pages/machines/_machineid/induction/index" */))
const _4f7870d6 = () => interopDefault(import('../pages/machines/_machineid/prepurchase/index.vue' /* webpackChunkName: "pages/machines/_machineid/prepurchase/index" */))
const _163c2e2f = () => interopDefault(import('../pages/sites/_siteid/view.vue' /* webpackChunkName: "pages/sites/_siteid/view" */))
const _bc19d51c = () => interopDefault(import('../pages/sites/_siteid/view/index.vue' /* webpackChunkName: "pages/sites/_siteid/view/index" */))
const _6ec8aa4e = () => interopDefault(import('../pages/sites/_siteid/view/covid-qr.vue' /* webpackChunkName: "pages/sites/_siteid/view/covid-qr" */))
const _388f1890 = () => interopDefault(import('../pages/sites/_siteid/view/emergency-information.vue' /* webpackChunkName: "pages/sites/_siteid/view/emergency-information" */))
const _f6a966d2 = () => interopDefault(import('../pages/sites/_siteid/view/files.vue' /* webpackChunkName: "pages/sites/_siteid/view/files" */))
const _e726b954 = () => interopDefault(import('../pages/sites/_siteid/view/hazard-id.vue' /* webpackChunkName: "pages/sites/_siteid/view/hazard-id" */))
const _d8d20e72 = () => interopDefault(import('../pages/sites/_siteid/view/more-forms.vue' /* webpackChunkName: "pages/sites/_siteid/view/more-forms" */))
const _23c371d5 = () => interopDefault(import('../pages/sites/_siteid/view/visitors.vue' /* webpackChunkName: "pages/sites/_siteid/view/visitors" */))
const _5d70d754 = () => interopDefault(import('../pages/sites/_siteid/visitor.vue' /* webpackChunkName: "pages/sites/_siteid/visitor" */))
const _548b8ed7 = () => interopDefault(import('../pages/sites/_siteid/visitor/index.vue' /* webpackChunkName: "pages/sites/_siteid/visitor/index" */))
const _dc9340bc = () => interopDefault(import('../pages/sites/_siteid/visitor/addressbook.vue' /* webpackChunkName: "pages/sites/_siteid/visitor/addressbook" */))
const _2fc0e240 = () => interopDefault(import('../pages/sites/_siteid/visitor/contractor.vue' /* webpackChunkName: "pages/sites/_siteid/visitor/contractor" */))
const _34653bbe = () => interopDefault(import('../pages/sites/_siteid/visitor/infrequent.vue' /* webpackChunkName: "pages/sites/_siteid/visitor/infrequent" */))
const _30e4b942 = () => interopDefault(import('../pages/vehicles/_vehicleid/edit.vue' /* webpackChunkName: "pages/vehicles/_vehicleid/edit" */))
const _10225fef = () => interopDefault(import('../pages/vehicles/_vehicleid/files.vue' /* webpackChunkName: "pages/vehicles/_vehicleid/files" */))
const _4092777c = () => interopDefault(import('../pages/vehicles/_vehicleid/induction/index.vue' /* webpackChunkName: "pages/vehicles/_vehicleid/induction/index" */))
const _29ee7a60 = () => interopDefault(import('../pages/contractors/_companyid/reviews/new.vue' /* webpackChunkName: "pages/contractors/_companyid/reviews/new" */))
const _f2eb0f5a = () => interopDefault(import('../pages/crews/_crewid/audits/new.vue' /* webpackChunkName: "pages/crews/_crewid/audits/new" */))
const _c2b5a754 = () => interopDefault(import('../pages/crews/_crewid/emergency-drill/new.vue' /* webpackChunkName: "pages/crews/_crewid/emergency-drill/new" */))
const _7d7f9204 = () => interopDefault(import('../pages/crews/_crewid/safe-start-stop/new.vue' /* webpackChunkName: "pages/crews/_crewid/safe-start-stop/new" */))
const _1c54d89b = () => interopDefault(import('../pages/crews/_crewid/safety-meeting/new.vue' /* webpackChunkName: "pages/crews/_crewid/safety-meeting/new" */))
const _bfe25a06 = () => interopDefault(import('../pages/crews/_crewid/safety-review/health-representative-review.vue' /* webpackChunkName: "pages/crews/_crewid/safety-review/health-representative-review" */))
const _52ac556a = () => interopDefault(import('../pages/crews/_crewid/safety-review/new.vue' /* webpackChunkName: "pages/crews/_crewid/safety-review/new" */))
const _efd7ee06 = () => interopDefault(import('../pages/crews/_crewid/safety-review/site-supervisor-review.vue' /* webpackChunkName: "pages/crews/_crewid/safety-review/site-supervisor-review" */))
const _470e4e51 = () => interopDefault(import('../pages/crews/_crewid/safety-review/worker-review.vue' /* webpackChunkName: "pages/crews/_crewid/safety-review/worker-review" */))
const _767eb787 = () => interopDefault(import('../pages/crews/_crewid/safety-sheets/add.vue' /* webpackChunkName: "pages/crews/_crewid/safety-sheets/add" */))
const _62c7a6ae = () => interopDefault(import('../pages/crews/_crewid/systems-audit/new.vue' /* webpackChunkName: "pages/crews/_crewid/systems-audit/new" */))
const _2b6c4882 = () => interopDefault(import('../pages/employees/_id/forms/da-consent.vue' /* webpackChunkName: "pages/employees/_id/forms/da-consent" */))
const _3c932e89 = () => interopDefault(import('../pages/employees/_id/forms/rol-request.vue' /* webpackChunkName: "pages/employees/_id/forms/rol-request" */))
const _357ac121 = () => interopDefault(import('../pages/employees/_id/medical-information/edit.vue' /* webpackChunkName: "pages/employees/_id/medical-information/edit" */))
const _f924bc1c = () => interopDefault(import('../pages/employees/_id/record-learning/request.vue' /* webpackChunkName: "pages/employees/_id/record-learning/request" */))
const _590f52cc = () => interopDefault(import('../pages/equipments/_equipmentid/induction/edit.vue' /* webpackChunkName: "pages/equipments/_equipmentid/induction/edit" */))
const _2d1dbd9e = () => interopDefault(import('../pages/equipments/_equipmentid/prepurchase/new.vue' /* webpackChunkName: "pages/equipments/_equipmentid/prepurchase/new" */))
const _7010bcd5 = () => interopDefault(import('../pages/machines/_machineid/checklist/edit.vue' /* webpackChunkName: "pages/machines/_machineid/checklist/edit" */))
const _919d64cc = () => interopDefault(import('../pages/machines/_machineid/induction/edit.vue' /* webpackChunkName: "pages/machines/_machineid/induction/edit" */))
const _4f8e8023 = () => interopDefault(import('../pages/machines/_machineid/prepurchase/new.vue' /* webpackChunkName: "pages/machines/_machineid/prepurchase/new" */))
const _68b54c5a = () => interopDefault(import('../pages/sites/_siteid/emergency-information/edit.vue' /* webpackChunkName: "pages/sites/_siteid/emergency-information/edit" */))
const _07d8758a = () => interopDefault(import('../pages/sites/_siteid/enviromentalchecklist/new.vue' /* webpackChunkName: "pages/sites/_siteid/enviromentalchecklist/new" */))
const _57b37c66 = () => interopDefault(import('../pages/sites/_siteid/hazard-id/edit.vue' /* webpackChunkName: "pages/sites/_siteid/hazard-id/edit" */))
const _d45a703e = () => interopDefault(import('../pages/sites/_siteid/presite/new.vue' /* webpackChunkName: "pages/sites/_siteid/presite/new" */))
const _20fecc50 = () => interopDefault(import('../pages/vehicles/_vehicleid/induction/edit.vue' /* webpackChunkName: "pages/vehicles/_vehicleid/induction/edit" */))
const _177de3bd = () => interopDefault(import('../pages/crews/_crewid/sbos/new/_formid.vue' /* webpackChunkName: "pages/crews/_crewid/sbos/new/_formid" */))
const _733edbf8 = () => interopDefault(import('../pages/crews/_crewid/toolbox/new/_toolboxid.vue' /* webpackChunkName: "pages/crews/_crewid/toolbox/new/_toolboxid" */))
const _8e3b3afe = () => interopDefault(import('../pages/crews/_crewid/sbos/view/_formid/_id.vue' /* webpackChunkName: "pages/crews/_crewid/sbos/view/_formid/_id" */))
const _7d94b3e5 = () => interopDefault(import('../pages/crews/_crewid/toolbox/view/_formid/_id.vue' /* webpackChunkName: "pages/crews/_crewid/toolbox/view/_formid/_id" */))
const _1638a57a = () => interopDefault(import('../pages/contractors/_companyid/reviews/_id.vue' /* webpackChunkName: "pages/contractors/_companyid/reviews/_id" */))
const _dc357fd4 = () => interopDefault(import('../pages/crews/_crewid/audits/_form.vue' /* webpackChunkName: "pages/crews/_crewid/audits/_form" */))
const _72d4a36d = () => interopDefault(import('../pages/crews/_crewid/audits/_id.vue' /* webpackChunkName: "pages/crews/_crewid/audits/_id" */))
const _04b839da = () => interopDefault(import('../pages/crews/_crewid/audits/_view_audit.vue' /* webpackChunkName: "pages/crews/_crewid/audits/_view_audit" */))
const _2ff0f99e = () => interopDefault(import('../pages/crews/_crewid/emergency-drill/_drillid.vue' /* webpackChunkName: "pages/crews/_crewid/emergency-drill/_drillid" */))
const _69c9bd1e = () => interopDefault(import('../pages/crews/_crewid/safe-start-stop/_id.vue' /* webpackChunkName: "pages/crews/_crewid/safe-start-stop/_id" */))
const _77a58c6c = () => interopDefault(import('../pages/crews/_crewid/safety-meeting/_meetingid.vue' /* webpackChunkName: "pages/crews/_crewid/safety-meeting/_meetingid" */))
const _8a33507a = () => interopDefault(import('../pages/crews/_crewid/systems-audit/_id.vue' /* webpackChunkName: "pages/crews/_crewid/systems-audit/_id" */))
const _2f441f56 = () => interopDefault(import('../pages/sites/_siteid/enviromentalchecklist/_id.vue' /* webpackChunkName: "pages/sites/_siteid/enviromentalchecklist/_id" */))
const _fbc61a0a = () => interopDefault(import('../pages/sites/_siteid/presite/_id.vue' /* webpackChunkName: "pages/sites/_siteid/presite/_id" */))
const _be8434a0 = () => interopDefault(import('../pages/crews/_crewid/safety-review/_id/meeting.vue' /* webpackChunkName: "pages/crews/_crewid/safety-review/_id/meeting" */))
const _5e89391d = () => interopDefault(import('../pages/crews/_crewid/safety-review/_id/meeting.unit.js' /* webpackChunkName: "pages/crews/_crewid/safety-review/_id/meeting.unit" */))
const _5c3d7c1d = () => interopDefault(import('../pages/sites/_siteid/hazard-id/_id/view.vue' /* webpackChunkName: "pages/sites/_siteid/hazard-id/_id/view" */))
const _33d0b7ce = () => interopDefault(import('../pages/crews/_crewid/safety-review/_id/_type.vue' /* webpackChunkName: "pages/crews/_crewid/safety-review/_id/_type" */))
const _ba61511e = () => interopDefault(import('../pages/contractors/_companyid/_id/index.vue' /* webpackChunkName: "pages/contractors/_companyid/_id/index" */))
const _278262fc = () => interopDefault(import('../pages/sop/_id/_version.vue' /* webpackChunkName: "pages/sop/_id/_version" */))
const _5bb4be54 = () => interopDefault(import('../pages/contractors/_companyid/_id/view.vue' /* webpackChunkName: "pages/contractors/_companyid/_id/view" */))
const _13afaed9 = () => interopDefault(import('../pages/contractors/_companyid/_id/view/index.vue' /* webpackChunkName: "pages/contractors/_companyid/_id/view/index" */))
const _42eb9876 = () => interopDefault(import('../pages/contractors/_companyid/_id/view/file.vue' /* webpackChunkName: "pages/contractors/_companyid/_id/view/file" */))
const _9e89c894 = () => interopDefault(import('../pages/contractors/_companyid/_id/view/forms.vue' /* webpackChunkName: "pages/contractors/_companyid/_id/view/forms" */))
const _bfb3b84a = () => interopDefault(import('../pages/contractors/_companyid/_id/view/inductions.vue' /* webpackChunkName: "pages/contractors/_companyid/_id/view/inductions" */))
const _1535395b = () => interopDefault(import('../pages/contractors/_companyid/_id/worker-information/edit.vue' /* webpackChunkName: "pages/contractors/_companyid/_id/worker-information/edit" */))
const _73223989 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/address-book",
    component: _71d930fe,
    name: "address-book"
  }, {
    path: "/company",
    component: _6357f377,
    name: "company"
  }, {
    path: "/company-panel",
    component: _0b2693ae,
    name: "company-panel"
  }, {
    path: "/contractors",
    component: _d9c07250,
    name: "contractors"
  }, {
    path: "/crews",
    component: _969cf0a8,
    name: "crews"
  }, {
    path: "/employees",
    component: _fc6a1e82,
    name: "employees"
  }, {
    path: "/equipments",
    component: _16410dfe,
    name: "equipments"
  }, {
    path: "/hazard-register",
    component: _b2f06e90,
    name: "hazard-register"
  }, {
    path: "/incidents",
    component: _13f3141b,
    name: "incidents"
  }, {
    path: "/login",
    component: _3cc9dca0,
    name: "login"
  }, {
    path: "/machines",
    component: _2ebfc8e8,
    name: "machines"
  }, {
    path: "/reminders",
    component: _89afd70a,
    name: "reminders"
  }, {
    path: "/safety-alerts",
    component: _08ad5928,
    name: "safety-alerts"
  }, {
    path: "/settings",
    component: _4d2e8f3f,
    name: "settings"
  }, {
    path: "/sites",
    component: _5e6853f4,
    name: "sites"
  }, {
    path: "/summary",
    component: _497e3ac6,
    children: [{
      path: "",
      component: _308e3f60,
      name: "summary"
    }, {
      path: "crews",
      component: _ac614c80,
      name: "summary-crews"
    }, {
      path: "incidents",
      component: _06dde1ef,
      name: "summary-incidents"
    }]
  }, {
    path: "/support",
    component: _97fb0374,
    name: "support"
  }, {
    path: "/training-competency",
    component: _6a9d292c,
    name: "training-competency"
  }, {
    path: "/vehicles",
    component: _17f7a63a,
    name: "vehicles"
  }, {
    path: "/company-panel/view",
    component: _33f12e0e,
    children: [{
      path: "",
      component: _149590bc,
      name: "company-panel-view"
    }, {
      path: "edit-details",
      component: _023ba605,
      name: "company-panel-view-edit-details"
    }, {
      path: "manage-access",
      component: _3aed65b9,
      name: "company-panel-view-manage-access"
    }, {
      path: "manage-crews",
      component: _33079860,
      name: "company-panel-view-manage-crews"
    }, {
      path: "manage-employees",
      component: _40025ba3,
      name: "company-panel-view-manage-employees"
    }, {
      path: "manage-access/view",
      component: _4268a98e,
      children: [{
        path: "",
        component: _3d074d91,
        name: "company-panel-view-manage-access-view"
      }, {
        path: "groups",
        component: _f11287b6,
        name: "company-panel-view-manage-access-view-groups"
      }]
    }]
  }, {
    path: "/company/view",
    component: _43b66c10,
    children: [{
      path: "",
      component: _b334b2da,
      name: "company-view"
    }, {
      path: "files",
      component: _edc44490,
      name: "company-view-files"
    }, {
      path: "objectives",
      component: _de55dd2e,
      name: "company-view-objectives"
    }, {
      path: "policy",
      component: _5b626fc1,
      name: "company-view-policy"
    }]
  }, {
    path: "/contractors/company-files",
    component: _ba87d2a6,
    name: "contractors-company-files"
  }, {
    path: "/employees/new",
    component: _5841ebcd,
    name: "employees-new"
  }, {
    path: "/equipments/add",
    component: _118e0310,
    name: "equipments-add"
  }, {
    path: "/incidents/new",
    component: _0cd993ae,
    name: "incidents-new"
  }, {
    path: "/machines/add",
    component: _1981be92,
    name: "machines-add"
  }, {
    path: "/safety-alerts/new",
    component: _2dc315ba,
    name: "safety-alerts-new"
  }, {
    path: "/sites/register",
    component: _620c2e9f,
    children: [{
      path: "",
      component: _1305fc3c,
      name: "sites-register"
    }, {
      path: ":forestid",
      component: _49c719e7,
      name: "sites-register-forestid"
    }]
  }, {
    path: "/vehicles/add",
    component: _48b24772,
    name: "vehicles-add"
  }, {
    path: "/reminders/goto/crewgear",
    component: _18b60f45,
    name: "reminders-goto-crewgear"
  }, {
    path: "/reminders/goto/employeegear",
    component: _7d7d8ddc,
    name: "reminders-goto-employeegear"
  }, {
    path: "/company-panel/manage-access/group/:groupuuid?",
    component: _474cbe82,
    name: "company-panel-manage-access-group-groupuuid"
  }, {
    path: "/company-panel/manage-access/user/:useruuid?",
    component: _64e66e98,
    name: "company-panel-manage-access-user-useruuid"
  }, {
    path: "/company/program/:versionid",
    component: _cb25d5e6,
    name: "company-program-versionid"
  }, {
    path: "/company/program/:versionid?/policy",
    component: _2f6e5ef2,
    name: "company-program-versionid-policy"
  }, {
    path: "/employees/:id",
    component: _442f942a,
    name: "employees-id"
  }, {
    path: "/incidents/:id",
    component: _749ea986,
    name: "incidents-id"
  }, {
    path: "/sites/:siteid",
    component: _3ceb1590,
    name: "sites-siteid"
  }, {
    path: "/summarynew/:drillid?",
    component: _48433d23,
    name: "summarynew-drillid"
  }, {
    path: "/contractors/:companyid/agreement",
    component: _5e424ec1,
    name: "contractors-companyid-agreement"
  }, {
    path: "/contractors/:companyid/company-files",
    component: _2cdd315b,
    name: "contractors-companyid-company-files"
  }, {
    path: "/contractors/:companyid/reviews",
    component: _cae3b2dc,
    name: "contractors-companyid-reviews"
  }, {
    path: "/crews/:crewid/documents",
    component: _36b6f3de,
    children: [{
      path: "",
      component: _53e89be1,
      name: "crews-crewid-documents"
    }, {
      path: "files",
      component: _36a0d306,
      name: "crews-crewid-documents-files"
    }, {
      path: "gear-tracker",
      component: _338cfd3b,
      name: "crews-crewid-documents-gear-tracker"
    }, {
      path: "safe-start",
      component: _316fa4a3,
      name: "crews-crewid-documents-safe-start"
    }, {
      path: "substance-inv",
      component: _54a33523,
      name: "crews-crewid-documents-substance-inv"
    }]
  }, {
    path: "/crews/:crewid/monthly",
    component: _4933ca33,
    children: [{
      path: "",
      component: _c142c314,
      name: "crews-crewid-monthly"
    }, {
      path: "audits",
      component: _ef0c47f8,
      name: "crews-crewid-monthly-audits"
    }, {
      path: "emergency-drills",
      component: _82d4bf80,
      name: "crews-crewid-monthly-emergency-drills"
    }, {
      path: "safety-meetings",
      component: _18442c57,
      name: "crews-crewid-monthly-safety-meetings"
    }, {
      path: "safety-review",
      component: _5101b852,
      name: "crews-crewid-monthly-safety-review"
    }, {
      path: "sbos",
      component: _0fa7d7ff,
      name: "crews-crewid-monthly-sbos"
    }, {
      path: "system-audits",
      component: _4a3f9cfa,
      name: "crews-crewid-monthly-system-audits"
    }, {
      path: "toolbox",
      component: _7b22809a,
      name: "crews-crewid-monthly-toolbox"
    }, {
      path: "toolbox/toolbox.unit",
      component: _3c981330,
      name: "crews-crewid-monthly-toolbox-toolbox.unit"
    }]
  }, {
    path: "/employees/:id/edit",
    component: _001461e2,
    name: "employees-id-edit"
  }, {
    path: "/employees/:id/view",
    component: _30432e06,
    children: [{
      path: "",
      component: _26750480,
      name: "employees-id-view"
    }, {
      path: "compliance",
      component: _261bb0c6,
      name: "employees-id-view-compliance"
    }, {
      path: "drug-alcohol",
      component: _d752c83a,
      name: "employees-id-view-drug-alcohol"
    }, {
      path: "files",
      component: _61049636,
      name: "employees-id-view-files"
    }, {
      path: "forms",
      component: _ec5e2ac6,
      name: "employees-id-view-forms"
    }, {
      path: "induction",
      component: _90f76ca2,
      name: "employees-id-view-induction"
    }, {
      path: "linked",
      component: _5be498ca,
      name: "employees-id-view-linked"
    }, {
      path: "medical",
      component: _2d56fa7f,
      name: "employees-id-view-medical"
    }, {
      path: "ppe-tracker",
      component: _1d9b853e,
      name: "employees-id-view-ppe-tracker"
    }, {
      path: "record-learning",
      component: _df95daf0,
      name: "employees-id-view-record-learning"
    }, {
      path: "training-records",
      component: _35de535e,
      name: "employees-id-view-training-records"
    }]
  }, {
    path: "/equipments/:equipmentid/edit",
    component: _a0902a84,
    name: "equipments-equipmentid-edit"
  }, {
    path: "/equipments/:equipmentid/files",
    component: _6bb55df3,
    name: "equipments-equipmentid-files"
  }, {
    path: "/equipments/:equipmentid/induction",
    component: _0a92c080,
    name: "equipments-equipmentid-induction"
  }, {
    path: "/equipments/:equipmentid/prepurchase",
    component: _f7fb45ba,
    name: "equipments-equipmentid-prepurchase"
  }, {
    path: "/incidents/:id/edit",
    component: _6cff3106,
    name: "incidents-id-edit"
  }, {
    path: "/machines/:machineid/checklist",
    component: _5882d0d2,
    name: "machines-machineid-checklist"
  }, {
    path: "/machines/:machineid/edit",
    component: _03ff21e8,
    name: "machines-machineid-edit"
  }, {
    path: "/machines/:machineid/files",
    component: _33053936,
    name: "machines-machineid-files"
  }, {
    path: "/machines/:machineid/induction",
    component: _70b01f72,
    name: "machines-machineid-induction"
  }, {
    path: "/machines/:machineid/prepurchase",
    component: _4f7870d6,
    name: "machines-machineid-prepurchase"
  }, {
    path: "/sites/:siteid/view",
    component: _163c2e2f,
    children: [{
      path: "",
      component: _bc19d51c,
      name: "sites-siteid-view"
    }, {
      path: "covid-qr",
      component: _6ec8aa4e,
      name: "sites-siteid-view-covid-qr"
    }, {
      path: "emergency-information",
      component: _388f1890,
      name: "sites-siteid-view-emergency-information"
    }, {
      path: "files",
      component: _f6a966d2,
      name: "sites-siteid-view-files"
    }, {
      path: "hazard-id",
      component: _e726b954,
      name: "sites-siteid-view-hazard-id"
    }, {
      path: "more-forms",
      component: _d8d20e72,
      name: "sites-siteid-view-more-forms"
    }, {
      path: "visitors",
      component: _23c371d5,
      name: "sites-siteid-view-visitors"
    }]
  }, {
    path: "/sites/:siteid/visitor",
    component: _5d70d754,
    children: [{
      path: "",
      component: _548b8ed7,
      name: "sites-siteid-visitor"
    }, {
      path: "addressbook",
      component: _dc9340bc,
      name: "sites-siteid-visitor-addressbook"
    }, {
      path: "contractor",
      component: _2fc0e240,
      name: "sites-siteid-visitor-contractor"
    }, {
      path: "infrequent",
      component: _34653bbe,
      name: "sites-siteid-visitor-infrequent"
    }]
  }, {
    path: "/vehicles/:vehicleid/edit",
    component: _30e4b942,
    name: "vehicles-vehicleid-edit"
  }, {
    path: "/vehicles/:vehicleid/files",
    component: _10225fef,
    name: "vehicles-vehicleid-files"
  }, {
    path: "/vehicles/:vehicleid/induction",
    component: _4092777c,
    name: "vehicles-vehicleid-induction"
  }, {
    path: "/contractors/:companyid/reviews/new",
    component: _29ee7a60,
    name: "contractors-companyid-reviews-new"
  }, {
    path: "/crews/:crewid/audits/new",
    component: _f2eb0f5a,
    name: "crews-crewid-audits-new"
  }, {
    path: "/crews/:crewid/emergency-drill/new",
    component: _c2b5a754,
    name: "crews-crewid-emergency-drill-new"
  }, {
    path: "/crews/:crewid/safe-start-stop/new",
    component: _7d7f9204,
    name: "crews-crewid-safe-start-stop-new"
  }, {
    path: "/crews/:crewid/safety-meeting/new",
    component: _1c54d89b,
    name: "crews-crewid-safety-meeting-new"
  }, {
    path: "/crews/:crewid/safety-review/health-representative-review",
    component: _bfe25a06,
    name: "crews-crewid-safety-review-health-representative-review"
  }, {
    path: "/crews/:crewid/safety-review/new",
    component: _52ac556a,
    name: "crews-crewid-safety-review-new"
  }, {
    path: "/crews/:crewid/safety-review/site-supervisor-review",
    component: _efd7ee06,
    name: "crews-crewid-safety-review-site-supervisor-review"
  }, {
    path: "/crews/:crewid/safety-review/worker-review",
    component: _470e4e51,
    name: "crews-crewid-safety-review-worker-review"
  }, {
    path: "/crews/:crewid/safety-sheets/add",
    component: _767eb787,
    name: "crews-crewid-safety-sheets-add"
  }, {
    path: "/crews/:crewid/systems-audit/new",
    component: _62c7a6ae,
    name: "crews-crewid-systems-audit-new"
  }, {
    path: "/employees/:id/forms/da-consent",
    component: _2b6c4882,
    name: "employees-id-forms-da-consent"
  }, {
    path: "/employees/:id/forms/rol-request",
    component: _3c932e89,
    name: "employees-id-forms-rol-request"
  }, {
    path: "/employees/:id/medical-information/edit",
    component: _357ac121,
    name: "employees-id-medical-information-edit"
  }, {
    path: "/employees/:id/record-learning/request",
    component: _f924bc1c,
    name: "employees-id-record-learning-request"
  }, {
    path: "/equipments/:equipmentid/induction/edit",
    component: _590f52cc,
    name: "equipments-equipmentid-induction-edit"
  }, {
    path: "/equipments/:equipmentid/prepurchase/new",
    component: _2d1dbd9e,
    name: "equipments-equipmentid-prepurchase-new"
  }, {
    path: "/machines/:machineid/checklist/edit",
    component: _7010bcd5,
    name: "machines-machineid-checklist-edit"
  }, {
    path: "/machines/:machineid/induction/edit",
    component: _919d64cc,
    name: "machines-machineid-induction-edit"
  }, {
    path: "/machines/:machineid/prepurchase/new",
    component: _4f8e8023,
    name: "machines-machineid-prepurchase-new"
  }, {
    path: "/sites/:siteid/emergency-information/edit",
    component: _68b54c5a,
    name: "sites-siteid-emergency-information-edit"
  }, {
    path: "/sites/:siteid/enviromentalchecklist/new",
    component: _07d8758a,
    name: "sites-siteid-enviromentalchecklist-new"
  }, {
    path: "/sites/:siteid/hazard-id/edit",
    component: _57b37c66,
    name: "sites-siteid-hazard-id-edit"
  }, {
    path: "/sites/:siteid/presite/new",
    component: _d45a703e,
    name: "sites-siteid-presite-new"
  }, {
    path: "/vehicles/:vehicleid/induction/edit",
    component: _20fecc50,
    name: "vehicles-vehicleid-induction-edit"
  }, {
    path: "/crews/:crewid/sbos/new/:formid?",
    component: _177de3bd,
    name: "crews-crewid-sbos-new-formid"
  }, {
    path: "/crews/:crewid/toolbox/new/:toolboxid?",
    component: _733edbf8,
    name: "crews-crewid-toolbox-new-toolboxid"
  }, {
    path: "/crews/:crewid/sbos/view/:formid?/:id?",
    component: _8e3b3afe,
    name: "crews-crewid-sbos-view-formid-id"
  }, {
    path: "/crews/:crewid/toolbox/view/:formid?/:id?",
    component: _7d94b3e5,
    name: "crews-crewid-toolbox-view-formid-id"
  }, {
    path: "/contractors/:companyid/reviews/:id",
    component: _1638a57a,
    name: "contractors-companyid-reviews-id"
  }, {
    path: "/crews/:crewid/audits/:form?",
    component: _dc357fd4,
    name: "crews-crewid-audits-form"
  }, {
    path: "/crews/:crewid/audits/:id?",
    component: _72d4a36d,
    name: "crews-crewid-audits-id"
  }, {
    path: "/crews/:crewid/audits/:view_audit?",
    component: _04b839da,
    name: "crews-crewid-audits-view_audit"
  }, {
    path: "/crews/:crewid/emergency-drill/:drillid?",
    component: _2ff0f99e,
    name: "crews-crewid-emergency-drill-drillid"
  }, {
    path: "/crews/:crewid/safe-start-stop/:id?",
    component: _69c9bd1e,
    name: "crews-crewid-safe-start-stop-id"
  }, {
    path: "/crews/:crewid/safety-meeting/:meetingid?",
    component: _77a58c6c,
    name: "crews-crewid-safety-meeting-meetingid"
  }, {
    path: "/crews/:crewid/systems-audit/:id?",
    component: _8a33507a,
    name: "crews-crewid-systems-audit-id"
  }, {
    path: "/sites/:siteid/enviromentalchecklist/:id?",
    component: _2f441f56,
    name: "sites-siteid-enviromentalchecklist-id"
  }, {
    path: "/sites/:siteid/presite/:id?",
    component: _fbc61a0a,
    name: "sites-siteid-presite-id"
  }, {
    path: "/crews/:crewid/safety-review/:id?/meeting",
    component: _be8434a0,
    name: "crews-crewid-safety-review-id-meeting"
  }, {
    path: "/crews/:crewid/safety-review/:id?/meeting.unit",
    component: _5e89391d,
    name: "crews-crewid-safety-review-id-meeting.unit"
  }, {
    path: "/sites/:siteid/hazard-id/:id?/view",
    component: _5c3d7c1d,
    name: "sites-siteid-hazard-id-id-view"
  }, {
    path: "/crews/:crewid/safety-review/:id?/:type?",
    component: _33d0b7ce,
    name: "crews-crewid-safety-review-id-type"
  }, {
    path: "/contractors/:companyid/:id",
    component: _ba61511e,
    name: "contractors-companyid-id"
  }, {
    path: "/sop/:id?/:version?",
    component: _278262fc,
    name: "sop-id-version"
  }, {
    path: "/contractors/:companyid/:id?/view",
    component: _5bb4be54,
    children: [{
      path: "",
      component: _13afaed9,
      name: "contractors-companyid-id-view"
    }, {
      path: "file",
      component: _42eb9876,
      name: "contractors-companyid-id-view-file"
    }, {
      path: "forms",
      component: _9e89c894,
      name: "contractors-companyid-id-view-forms"
    }, {
      path: "inductions",
      component: _bfb3b84a,
      name: "contractors-companyid-id-view-inductions"
    }]
  }, {
    path: "/contractors/:companyid/:id?/worker-information/edit",
    component: _1535395b,
    name: "contractors-companyid-id-worker-information-edit"
  }, {
    path: "/",
    component: _73223989,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
